export default "__VITE_ASSET__bcfeb2b5__"